 import React, { Component } from 'react'
class Upload extends Component {
  constructor(props){
    super(props)
    this.state = {
      files: null,
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
      }
    }
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(event) {
    this.setState({
      ...this.state,
      file:{
        url: URL.createObjectURL(event.target.files[0]),
        type: event.target.files[0].type,
        size: event.target.files[0].size,
        name: event.target.files[0].name,
        blob: event.target.files[0]
      },
      files: event.target.files
    })
    this.props.onChange(event.target.files[0]);
  }
  render() {
    const {file} = {...this.state}
    return (
      <label className={'btn btn-default btn-upload-orange'}>
        <input type="file"
               style={{display: 'none'}} 
               onChange={this.handleChange} />
        <span className="glyphicon glyphicon-save" aria-hidden="true"></span>
      </label>
    );
  }
}
module.exports = Upload


/** WEBPACK FOOTER **
 ** ./src/components/FileField.js
 **/